import { ToolBadge } from '@/shared/ui/ToolBadge';
import { i18n } from '@/shared/i18n';

export const CATEGORY_GREETINGS_INFO = {
  plan: {
    // Getters, not values: resolving per read is what lets the copy follow a language change.
    get description() {
      return i18n.t('common:constants.categoryGreetings.seeAheadShapeStrategy');
    },
    get greeting() {
      return i18n.t('common:constants.categoryGreetings.makeSenseOfTheMessy');
    },
    // eslint-disable-next-line i18next/no-literal-string -- a category id, not copy
    icon: <ToolBadge toolId="strategy-agent" category="plan" size="2xl" />,
  },
  create: {
    get description() {
      return i18n.t('common:constants.categoryGreetings.buildSmarterShipFaster');
    },
    get greeting() {
      return i18n.t('common:constants.categoryGreetings.generateFreshIdeasCraft');
    },
    // eslint-disable-next-line i18next/no-literal-string -- a category id, not copy
    icon: <ToolBadge toolId="image-generation" category="create" size="2xl" />,
  },
  scale: {
    get description() {
      return i18n.t('common:constants.categoryGreetings.scaleSmarterAmplifyResults');
    },
    get greeting() {
      return i18n.t('common:constants.categoryGreetings.turnYourStrongestIdeasInto');
    },
    // eslint-disable-next-line i18next/no-literal-string -- a category id, not copy
    icon: <ToolBadge toolId="content-studio" category="scale" size="2xl" />,
  },
  deliver: {
    get description() {
      return i18n.t('common:constants.categoryGreetings.goLiveStayAhead');
    },
    get greeting() {
      return i18n.t('common:constants.categoryGreetings.launchWorkSeamlesslyKeep');
    },
    // eslint-disable-next-line i18next/no-literal-string -- a category id, not copy
    icon: <ToolBadge toolId="quality-assurance" category="deliver" size="2xl" />,
  },
  support: {
    get description() {
      return i18n.t('common:constants.categoryGreetings.getHelpKeepMoving');
    },
    get greeting() {
      return i18n.t('common:constants.categoryGreetings.neverGetStuckConnect');
    },
    // eslint-disable-next-line i18next/no-literal-string -- a category id, not copy
    icon: <ToolBadge toolId="general-support" category="support" size="2xl" />,
  },
} as const;
